module.exports = __webpack_public_path__ + "static/media/git.e6b832b0.svg";